<template>
<v-layout column>
    <v-flex>
        <v-container
          fluid
          grid-list-md
        >
        <div class = "primary">

        <v-subheader class="event"  style="height: 85px">  <img src= "/static/img/official_icons/event2.png" style= "max-width: 8ex; max-height: 8ex;">
        <h1 class="event" style="color:white; psition: relative; bottom: 10px">Personal Calender
      </h1> </v-subheader>
          </div>

           <v-text-field
            append-icon="search"
            box
            placeholder="Search an event, project, or todo..."
            v-model="search"
            >
            </v-text-field>


          <v-date-picker
        height = 150%
        width = 200%
        v-model="date"
        :events="functionEvents"
        :event-color="date => colorPicker(date)"
        landscape
        ></v-date-picker>

        <v-list two-line>
          <template v-for="event in events">

            <v-list-tile
              :key="event.id"
              v-if="show[event.date]"
              avatar
              @click="pushProject(event.projectID)"
            >
              <v-list-tile-avatar>
                <img :src="event.icon">
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-html="event.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html="event.projectTitle"></v-list-tile-sub-title>
                <v-list-tile-sub-title v-html="event.date"></v-list-tile-sub-title>
                <v-list-tile-sub-title v-html="event.time"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>

    </v-container>
    </v-flex>
    </v-layout>
</template>

<script>

import firebase from '../Firebase/FirebaseInit'
import router from '../router/index.js'

export default {
  data () {
    return {
      date: null,
      events: [],
      show: [],
      router,
      removed: [],
      todoCounter: 0,
      search: '',
      searchChange: false
    }
  },
  watch: {
    search () {
      this.show = this.show.map((boolean) => false)
      if (this.search) {
        let found = false
        for (var i = 0; i < this.events.length; i++) {
          var event = this.events[i]
          if (event.title.toLowerCase().includes(this.search.toLowerCase())) {
            this.show[event.date] = true
            if (!found) {
              this.searchChange = true
              this.date = event.date
              found = true
            }
          }
        }
      } else {
        this.date = null
      }
    },
    date () {
      if (!this.searchChange) {
        this.show = this.show.map((boolean) => false)
        let dates = this.events.map((event) => event.date)
        if (dates.includes(this.date)) {
          this.show[this.date] = true
        }
      } else {
        this.searchChange = false
      }
    }
  },
  methods: {
    pushProject (projectID) {
      this.$store.dispatch('Project', projectID)
      router.push('/project/' + projectID)
    },
    functionEvents (date) {
      let dates = this.events.map((event) => event.date)
      return (dates.includes(date))
    },
    colorPicker (date) {
      let selectedDates = (this.events.filter((event) => event.date === date))
      if (selectedDates.length > 1) {
        return 'red'
      } else {
        switch (selectedDates[0].type) {
          case 'meeting': return 'blue'
          case 'todo': return 'yellow'
        }
      }
    }
  },
  beforeCreate () {
    firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let projectID = doc.data().projectID
        firebase.firestore().collection('projects').doc(projectID).get().then((doc) => {
          let projectTitle = doc.data().title

          firebase.firestore().collection('projects').doc(projectID).collection('meeting').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data().members.includes(this.$store.getters.user.id)) {
                let title = doc.data().title
                let date = doc.data().startDate
                let time = doc.data().startTime
                let type = 'meeting'
                let icon = '../../static/img/official_icons/event2.png'
                let id = doc.data().id
                let event = {
                  projectID,
                  projectTitle,
                  title,
                  date,
                  time,
                  type,
                  icon,
                  id
                }
                this.events.push(event)
              }
            })
          })
          firebase.firestore().collection('projects').doc(projectID).collection('todo').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data().members === this.$store.getters.user.id || doc.data().creator === this.$store.getters.user.id) {
                let title = doc.data().title
                let date = doc.data().startDate
                let time = doc.data().startTime
                let type = 'todo'
                let icon = '../../static/img/official_icons/todo2.png'
                let id = doc.data().id
                this.todoCounter++
                let event = {
                  projectID,
                  projectTitle,
                  title,
                  date,
                  time,
                  type,
                  icon,
                  id
                }
                this.events.push(event)
              }
            })
          })
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// Calender.vue?1779f14a